import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
// import {slide as Menu} from 'react-burger-menu';
import SelectBox from '../form/SelectBox';
import { Link } from 'react-router-dom';
import { showResponsiveMenu } from '../../actions/common';
import { signout } from '../../actions/auth';
import { setFilter, setSort } from '../../actions/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setActiveLanguage, getTranslate, getActiveLanguage } from 'react-localize-redux';
import { languageOptions, currencyOptions } from '../../assets/constant';
import slugify from 'slugify';
import moment from 'moment'

import { getUserNotification, updateUserNotification } from '../../actions/notification/index'
import { ACCOUNT_MENU } from '../../assets/menu';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

class ResponsiveMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shopSubMenuVisible: false,
            aboutusMenuVisible: false,
            accountMenuOpen: false,
            localeMenuVisible: false,
        }

        this.renderCategory = this.renderCategory.bind(this);
        // this.setReadNotice = this.setReadNotice.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.update_notice === null && this.props.update_notice === true) {
            this.props.getUserNotification();
        }

        if (prevProps.onAccount !== this.props.onAccount) {
            this.setState({ accountMenuOpen: this.props.onAccount });
        }
    }

    renderCategory() {
        const { categories, currentLanguage } = this.props;
        return _.map(categories, (m, index) => {
            return <li key={index}><Link to={`/shop/${slugify(m.category, { lower: true })}`}>{currentLanguage === 'th' ? m.category_th : m.category}</Link></li>
        });
    }

    // setReadNotice(){
    //     this.props.updateUserNotification();
    // }

    render() {
        const { isOpen, authenticated, profile, count_notice } = this.props; //order_count
        const { shopSubMenuVisible, aboutusMenuVisible, accountMenuOpen, localeMenuVisible } = this.state;
        const { setActiveLanguage, currentLanguage, translate } = this.props;
        const role_id = profile ? profile.role_id : -1;
        return (
            <div id="side-menu" className={`bt-popup-backdrop ${isOpen ? "open" : ""}`} onClick={() => { this.props.showResponsiveMenu(false) }}>
                <div className={`bt-side-menu ${isOpen ? "open" : ""}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    <div className={`bt-side-general-menu ${accountMenuOpen ? "account-open" : ""}`}>
                        {!authenticated && <div className="close-btn" onClick={() => { this.props.showResponsiveMenu(false) }}><FontAwesomeIcon icon={faTimes} /></div>}
                        <ul>
                            {!authenticated && <li><Link className="login" to={`/login`}>เข้าสู่ระบบ / สมัครสมาชิก</Link></li>}
                            {authenticated &&
                                <li>
                                    <div className="authenticated d-flex justify-content-between align-items-center mr-4" onClick={() => this.setState({ accountMenuOpen: true })}>
                                        <span>{translate('HI')} {profile ? profile.first_name : ""}
                                            {count_notice > 0 ?
                                                <span className="notice-response ml-2 notice-count">{count_notice}</span> : ""
                                            }
                                        </span>
                                        <FontAwesomeIcon icon={["fal", "chevron-right"]} />
                                    </div>
                                </li>}
                            <li className={`main-menu ${shopSubMenuVisible ? "sub-open" : ""}`}>
                                <div className="d-flex justify-content-between align-items-center mr-4" onClick={() => { this.setState({ shopSubMenuVisible: !shopSubMenuVisible }) }}>{translate('SHOP_CATEGORY')}<FontAwesomeIcon icon={["fal", "chevron-right"]} /></div>
                                <ul className={`sub-menu ${shopSubMenuVisible ? "open" : ""}`}>
                                    {this.renderCategory()}
                                </ul>
                            </li>
                            <li><Link className="" to={`/deals`} >{translate('PROMO')}</Link></li>
                            {moment().isBefore("2020-01-24 00:00:00", 's') && <li><Link className="" to={`/best-sellers`} >{translate('BEST_SELL')}</Link></li>}
                            {moment().isBetween("2021-06-05 16:00:00", "2021-06-06 23:59:59", "s", "[]") && <li><Link to="/flashsale">Flash Sale</Link></li>}
                            <li><Link className="" to={`/shop`} onClick={() => { this.props.setSort({ value: 'new_arrivals' }) }}>{translate('NEW_IN')}</Link></li>
                            <li><Link className="" to={`/brands`}>{translate('BRANDS')}</Link></li>
                            {moment().isSameOrAfter("2024-08-07 00:00:00", 'd') && <li className=""><Link to="/exclusiveedition">Exclusive Edition</Link></li>}
                            <li><Link className="" to={`/blogs`}>{translate('BLOGS')}</Link></li>
                            <li><Link className="" to={"/campaign/giveaway"}>{translate('CAMPAIGN.GIVEAWAY')}</Link></li>
                            {[0, 4, 80].includes(role_id) && <li><Link to="/chat_order"><div>Create Order</div></Link></li>}
                            {/* <li><Link className="" to={`/reviews`}>Reviews</Link></li> */}
                            <li className={`main-menu about-us ${aboutusMenuVisible ? "sub-open" : ""}`}>
                                <div className="d-flex justify-content-between align-items-center mr-4" onClick={() => { this.setState({ aboutusMenuVisible: !aboutusMenuVisible }) }}>{translate('ABOUT_US')}<FontAwesomeIcon icon={["fal", "chevron-right"]} /></div>
                                <ul className={`sub-menu ${aboutusMenuVisible ? "open" : ""}`}>
                                    <li><Link to={`/aboutus`}>เกี่ยวกับเรา</Link></li>
                                    <li><Link to={`/contactus`}>ติดต่อเรา</Link></li>
                                    <li><Link to={`/store_locations`}>ที่ตั้งสาขา</Link></li>
                                </ul>
                            </li>
                            <li>
                                <ul className="last-menus">
                                    <li className={`main-menu ${localeMenuVisible && "sub-open"}`}>
                                        <div onClick={() => this.setState((prev) => {
                                            return { localeMenuVisible: !prev.localeMenuVisible }
                                        })}>ภาษาไทย | บาทไทย <FontAwesomeIcon icon={["fal", "chevron-right"]} className="ml-2" /></div>
                                        <div className={`sub-menu mr-4 ${localeMenuVisible && "open"}`}>
                                            <div className='col-12 text-left px-0 mb-2 mt-3'>
                                                <span className="header">Language</span>
                                            </div>
                                            <div className='col-12 text-left px-0 mb-4'>
                                                <SelectBox options={languageOptions} selectedOption={_.filter(languageOptions, (l) => l.value === currentLanguage.code)} onChange={(v) => { setActiveLanguage(v.value); }} />
                                            </div>
                                            <div className='col-12 text-left px-0 mb-2'>
                                                <span className="header">Currency</span>
                                            </div>
                                            <div className='col-12 text-left px-0'>
                                                <SelectBox options={currencyOptions} selectedOption={currencyOptions[0]} />
                                            </div>
                                        </div>
                                    </li>
                                    <li><span onClick={this.props.showTrackOrder}>ติดตามสินค้า</span></li>
                                    <li><Link to={`/upload_receipt`}>แจ้งชำระเงิน</Link></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div className={`bt-side-account-menu ${accountMenuOpen ? "open" : ""}`}>
                        {accountMenuOpen && <ul>
                            <li className="account-header" onClick={() => setTimeout(this.setState({ accountMenuOpen: false }), 500)}>
                                <div className="d-flex flex-row align-items-center">
                                    <FontAwesomeIcon icon={["fal", "chevron-left"]} />
                                    <div className="">
                                        <div className="account-name">{(profile !== null && profile.first_name) ? profile.first_name : "Undefined Name"}</div>
                                        {/* <div className="account-point">My BEAUTRIUM Point: 50</div> */}
                                    </div>
                                </div>
                            </li>
                            {_.map(ACCOUNT_MENU, (menu, i) => {
                                if (menu.disabled) {
                                    return null;
                                }
                                return (
                                    <li key={`account_menu_resp_${i}_${menu.key}`}>
                                        <Link to={menu.link}>
                                            {menu.icon}
                                            {menu.key
                                                ? translate(menu.key)
                                                : menu.name
                                            }
                                        </Link>
                                    </li>
                                )
                            })}
                            <li><span onClick={() => { this.setState({ accountMenuOpen: false }); this.props.signout() }}><FontAwesomeIcon icon={["fas", "sign-out-alt"]} />ออกจากระบบ</span></li>
                        </ul>}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isOpen: state.common.show_responsive_menu,
        authenticated: state.auth.authenticated,
        profile: state.prof.profile,
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale),
        count_notice: state.notice.count_notice,
        // order_count: state.notice.order_count,
        update_notice: state.notice.updateUserNotification,
        categories: state.itemCategories.categories,
    }
}
export default connect(mapStateToProps, { showResponsiveMenu, signout, setFilter, setSort, setActiveLanguage, getUserNotification, updateUserNotification })(ResponsiveMenu)